// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset the host element — cuts CSS inheritance from parent elements
(line-height, font-size, color, etc. from .form-row stop here). */
text-editor {
  all: initial;
  display: block;
  font-size: inherit;
  font-family: inherit;
  border: 1px solid #f0f0f3;
  border-radius: 10px;

  /* Reset all children to browser defaults. */
  & * {
    all: revert-layer;
  }

  & svg {
    width: 18px;
    height: 18px;
  }

  & button:focus {
    outline: none;
  }

  & .mdxeditor-toolbar {
    gap: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    & svg {
      height: 24px;
    }

    & div[role="separator"] {
      margin: 0;
    }
  }

  /* MDXEditor content styles (restore what the global CSS reset strips) */
  & .mdxeditor-root-contenteditable blockquote {
    border-left: 3px solid #b0b0b0;
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    margin-left: 0;
    padding-left: 1em;
    color: #555;
    font-style: italic;
  }
}

.ui-dialog text-editor button {
  font-size: inherit;
  font-family: inherit;
}

/* Raise portaled popper/tooltip elements above the jQuery UI dialog */
.mdxeditor.mdxeditor-popup-container {
  z-index: 2100;
}
`, "",{"version":3,"sources":["webpack://./src/TextEditor/TextEditor.css"],"names":[],"mappings":"AAAA;iEACiE;AACjE;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;;EAEnB,4CAA4C;EAC5C;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,MAAM;IACN,4BAA4B;IAC5B,6BAA6B;;IAE7B;MACE,YAAY;IACd;;IAEA;MACE,SAAS;IACX;EACF;;EAEA,wEAAwE;EACxE;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,aAAa;AACf","sourcesContent":["/* Reset the host element — cuts CSS inheritance from parent elements\n(line-height, font-size, color, etc. from .form-row stop here). */\ntext-editor {\n  all: initial;\n  display: block;\n  font-size: inherit;\n  font-family: inherit;\n  border: 1px solid #f0f0f3;\n  border-radius: 10px;\n\n  /* Reset all children to browser defaults. */\n  & * {\n    all: revert-layer;\n  }\n\n  & svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  & button:focus {\n    outline: none;\n  }\n\n  & .mdxeditor-toolbar {\n    gap: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n    & svg {\n      height: 24px;\n    }\n\n    & div[role=\"separator\"] {\n      margin: 0;\n    }\n  }\n\n  /* MDXEditor content styles (restore what the global CSS reset strips) */\n  & .mdxeditor-root-contenteditable blockquote {\n    border-left: 3px solid #b0b0b0;\n    margin-top: 1.6em;\n    margin-bottom: 1.6em;\n    margin-left: 0;\n    padding-left: 1em;\n    color: #555;\n    font-style: italic;\n  }\n}\n\n.ui-dialog text-editor button {\n  font-size: inherit;\n  font-family: inherit;\n}\n\n/* Raise portaled popper/tooltip elements above the jQuery UI dialog */\n.mdxeditor.mdxeditor-popup-container {\n  z-index: 2100;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
